import {TeamObject} from "@/types";

export const TEAMS : {[key: string]: TeamObject;} = {
  "A&M Commerce": {
    logo: "texas_a_m_commerce.png",
    endzone_abbreviation: "TAMU-C",
    endzone_hex_color: "004C97",
    alternate_mascots: [],
    alternate_names: [],
  },
  "AIC": {
    logo: "american_international.png",
    endzone_abbreviation: "AIC",
    endzone_hex_color: "FFB81C",
    alternate_mascots: [],
    alternate_names: [],
  },
  "Abilene Christian": {
    logo: "abilene_christian.png",
    endzone_abbreviation: "ACU",
    endzone_hex_color: "461D7C",
    alternate_mascots: [],
    alternate_names: [],
  },
  "Air Force": {
    logo: "air_force.png",
    mascots: "Falcons",
    endzone_abbreviation: "AF",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Falcons"],
    alternate_names: [],
  },
  "Akron": {
    logo: "akron.png",
    mascots: "Zips",
    endzone_abbreviation: "AKR",
    endzone_hex_color: "041E42",
    alternate_mascots: ["Lady Zips"],
    alternate_names: [],
  },
  "Alabama": {
    logo: "alabama.png",
    mascots: "Crimson Tide",
    endzone_abbreviation: "BAMA",
    alternate_names: ["University of Alabama"],
    endzone_hex_color: "9E1B32",
    alternate_mascots: ["Lady Crimson Tide"],
  },
  "Alabama A&M": {
    logo: "alabama_a_m.png",
    endzone_abbreviation: "AAMU",
    endzone_hex_color: "660000",
    alternate_mascots: [],
    alternate_names: [],
  },
  "Alabama State": {
    logo: "alabama_state.png",
    alternate_names: ["Alabama St.", "Alabama St"],
    endzone_abbreviation: "ALST",
    endzone_hex_color: "000000",
    alternate_mascots: [],
  },
  "Alabama-Huntsville": {
    logo: "alabama_huntsville.png",
    endzone_abbreviation: "UAH",
    endzone_hex_color: "0033A0",
    alternate_mascots: [],
    alternate_names: [],
  },
  "Alaska": {
    logo: "alaska.png",
    endzone_abbreviation: "AK",
    endzone_hex_color: "003366",
    alternate_mascots: [],
    alternate_names: [],
  },
  "Alaska-Anchorage": {
    logo: "alaska_anchorage.png",
    endzone_abbreviation: "UAA",
    endzone_hex_color: "00563F",
    alternate_mascots: [],
    alternate_names: [],
  },
  "Albany": {
    logo: "albany.png",
    endzone_abbreviation: "ALB",
    endzone_hex_color: "461D7C",
    alternate_mascots: [],
    alternate_names: [],
  },
  "Alcorn State": {
    logo: "alcorn_state.png",
    alternate_names: ["Alcorn St.", "Alcorn St"],
    endzone_abbreviation: "ALC",
    endzone_hex_color: "461D7C",
    alternate_mascots: [],
  },
  "American": {
    logo: "american.png",
    endzone_abbreviation: "AMER",
    endzone_hex_color: "C41E3A",
    alternate_mascots: [],
    alternate_names: [],
  },
  "Appalachian State": {
    logo: "appalachian_state.png",
    mascots: "Mountaineers",
    alternate_names: ["Appalachian St.", "Appalachian St"],
    endzone_abbreviation: "APP",
    endzone_hex_color: "000000",
    alternate_mascots: ["Lady Mountaineers"],
  },
  "Arizona": {
    logo: "arizona.png",
    mascots: "Wildcats",
    endzone_abbreviation: "ARIZ",
    endzone_hex_color: "003366",
    alternate_mascots: ["Lady Wildcats"],
    alternate_names: [],
  },
  "Arizona State": {
    logo: "arizona_state.png",
    mascots: "Sun Devils",
    alternate_names: ["Arizona St.", "Arizona St"],
    endzone_abbreviation: "ASU",
    endzone_hex_color: "8C1D40",
    alternate_mascots: ["Lady Sun Devils"],
  },
  "Arkansas": {
    logo: "arkansas.png",
    mascots: "Razorbacks",
    endzone_abbreviation: "ARK",
    endzone_hex_color: "9D2235",
    alternate_mascots: ["Lady Razorbacks"],
    alternate_names: [],
  },
  "Arkansas State": {
    logo: "arkansas_state.png",
    alternate_names: ["Arkansas St.", "Arkansas St"],
    endzone_abbreviation: "ASU",
    endzone_hex_color: "CC0000",
    alternate_mascots: [],
  },
  "Arkansas-Pine Bluff": {
    logo: "arkansas_pine_bluff.png",
    endzone_abbreviation: "APB",
    endzone_hex_color: "000000",
    alternate_mascots: [],
    alternate_names: [],
  },
  "Army": {
    logo: "army.png",
    alternate_names: ["Army West Point"],
    endzone_abbreviation: "ARMY",
    endzone_hex_color: "000000",
    alternate_mascots: [],
  },
  "Auburn": {
    logo: "auburn.png",
    mascots: "Tigers",
    endzone_abbreviation: "AUB",
    endzone_hex_color: "0C2340",
    alternate_mascots: ["Lady Tigers"],
    alternate_names: [],
  },
  "Austin Peay": {
    logo: "austin_peay.png",
    endzone_abbreviation: "APSU",
    endzone_hex_color: "C41E3A",
    alternate_mascots: [],
    alternate_names: [],
  },
  "BYU": {
    logo: "brigham_young.png",
    mascots: "Cougars",
    endzone_abbreviation: "BYU",
    endzone_hex_color: "002E5D",
    alternate_mascots: ["Lady Cougars"],
    alternate_names: [],
  },
  "Ball State": {
    logo: "ball_state.png",
    alternate_names: ["Ball St.", "Ball St"],
    endzone_abbreviation: "BSU",
    endzone_hex_color: "BA0C2F",
    alternate_mascots: [],
  },
  "Baylor": {
    logo: "baylor.png",
    mascots: "Bears",
    endzone_abbreviation: "BAY",
    endzone_hex_color: "003015",
    alternate_mascots: ["Lady Bears"],
    alternate_names: [],
  },
  "Bellarmine": {
    logo: "bellarmine.png",
    endzone_abbreviation: "BEL",
    endzone_hex_color: "C8102E",
    alternate_mascots: [],
    alternate_names: [],
  },
  "Belmont": {
    logo: "belmont.png",
    endzone_abbreviation: "BELM",
    endzone_hex_color: "003087",
    alternate_mascots: [],
    alternate_names: [],
  },
  "Bemidji State": {
    logo: "bemidji_state.png",
    alternate_names: ["Bemidji St.", "Bemidji St"],
    endzone_abbreviation: "BSU",
    endzone_hex_color: "00563F",
    alternate_mascots: [],
  },
  "Bentley": {
    logo: "bentley.png",
    endzone_abbreviation: "BENT",
    endzone_hex_color: "003087",
    alternate_mascots: [],
    alternate_names: [],
  },
  "Bethune-Cookman": {
    logo: "bethune_cookman.png",
    endzone_abbreviation: "BCU",
    endzone_hex_color: "862633",
    alternate_mascots: [],
    alternate_names: [],
  },
  "Binghamton": {
    logo: "binghamton.png",
    endzone_abbreviation: "BING",
    endzone_hex_color: "00543C",
    alternate_mascots: [],
    alternate_names: [],
  },
  "Boise State": {
    logo: "boise_state.png",
    mascots: "Broncos",
    alternate_names: ["Boise St.", "Boise St"],
    endzone_abbreviation: "BSU",
    endzone_hex_color: "0033A0",
    alternate_mascots: ["Lady Broncos"],
  },
  "Boston": {
    logo: "boston.png",
    endzone_abbreviation: "BU",
    endzone_hex_color: "CC0000",
    alternate_mascots: [],
    alternate_names: [],
  },
  "Boston College": {
    logo: "boston_college.png",
    mascots: "Eagles",
    endzone_abbreviation: "BC",
    endzone_hex_color: "8B0015",
    alternate_mascots: ["Lady Eagles"],
    alternate_names: [],
  },
  "Bowling Green": {
    logo: "bowling_green.png",
    mascots: "Falcons",
    endzone_abbreviation: "BGSU",
    endzone_hex_color: "FE5000",
    alternate_mascots: ["Lady Falcons"],
    alternate_names: [],
  },
  "Bradley": {
    logo: "bradley.png",
    mascots: "Braves",
    endzone_abbreviation: "BRAD",
    endzone_hex_color: "CE1126",
    alternate_mascots: ["Lady Braves"],
    alternate_names: [],
  },
  "Brooklyn St. Francis": {
    logo: "brooklyn_saint_francis.png",
    mascots: "Terriers",
    endzone_abbreviation: "SFNY",
    endzone_hex_color: "0033A0",
    alternate_mascots: ["Lady Terriers"],
    alternate_names: [],
  },
  "Brown": {
    logo: "brown.png",
    mascots: "Bears",
    endzone_abbreviation: "BROWN",
    endzone_hex_color: "4E3629",
    alternate_mascots: ["Lady Bears"],
    alternate_names: [],
  },
  "Bryant": {
    logo: "bryant.png",
    mascots: "Bulldogs",
    endzone_abbreviation: "BRY",
    endzone_hex_color: "000000",
    alternate_mascots: ["Lady Bulldogs"],
    alternate_names: [],
  },
  "Bucknell": {
    logo: "bucknell.png",
    mascots: "Bison",
    endzone_abbreviation: "BUCK",
    endzone_hex_color: "003C71",
    alternate_mascots: ["Lady Bison"],
    alternate_names: [],
  },
  "Buffalo": {
    logo: "buffalo.png",
    mascots: "Bulls",
    endzone_abbreviation: "BUF",
    endzone_hex_color: "005BBB",
    alternate_mascots: ["Lady Bulls"],
    alternate_names: [],
  },
  "Butler": {
    logo: "butler.png",
    mascots: "Bulldogs",
    endzone_abbreviation: "BUT",
    endzone_hex_color: "13294B",
    alternate_mascots: ["Lady Bulldogs"],
    alternate_names: [],
  },
  "CSU Bakersfield": {
    logo: "california_state_bakersfield.png",
    mascots: "Roadrunners",
    endzone_abbreviation: "CSUB",
    endzone_hex_color: "003DA5",
    alternate_mascots: ["Lady Roadrunners"],
    alternate_names: [],
  },
  "Cal Baptist": {
    logo: "california_baptist.png",
    mascots: "Lancers",
    endzone_abbreviation: "CBU",
    alternate_names: ["California Baptist"],
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Lancers"],
  },
  "Cal Poly": {
    logo: "california_poly.png",
    mascots: "Mustangs",
    endzone_abbreviation: "CP",
    endzone_hex_color: "154734",
    alternate_mascots: ["Lady Mustangs"],
    alternate_names: [],
  },
  "Cal State Fullerton": {
    logo: "california_state_fullerton.png",
    mascots: "Titans",
    alternate_names: ["Cal St. Fullerton", "Cal St Fullerton"],
    endzone_abbreviation: "CSF",
    endzone_hex_color: "003262",
    alternate_mascots: ["Lady Titans"],
  },
  "Cal State Northridge": {
    logo: "california_state_northridge.png",
    mascots: "Matadors",
    alternate_names: ["Cal St. Northridge", "Cal St Northridge"],
    endzone_abbreviation: "CSUN",
    endzone_hex_color: "D01F2D",
    alternate_mascots: ["Lady Matadors"],
  },
  "California": {
    logo: "california.png",
    mascots: "Golden Bears",
    alternate_names: ["Cal"],
    endzone_abbreviation: "CAL",
    endzone_hex_color: "003262",
    alternate_mascots: ["Lady Golden Bears"],
  },
  "Campbell": {
    logo: "campbell.png",
    mascots: "Fighting Camels",
    endzone_abbreviation: "CAM",
    endzone_hex_color: "FF6A00",
    alternate_mascots: ["Lady Fighting Camels"],
    alternate_names: [],
  },
  "Canisius": {
    logo: "canisius.png",
    mascots: "Golden Griffins",
    endzone_abbreviation: "CAN",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Golden Griffins"],
    alternate_names: [],
  },
  "Centenary": {
    logo: "centenary.png",
    mascots: "Gentlemen",
    endzone_abbreviation: "CENT",
    endzone_hex_color: "660000",
    alternate_mascots: ["Lady Gentlemen"],
    alternate_names: [],
  },
  "Central Arkansas": {
    logo: "central_arkansas.png",
    mascots: "Bears",
    endzone_abbreviation: "CARK",
    endzone_hex_color: "461D7C",
    alternate_mascots: ["Lady Bears"],
    alternate_names: [],
  },
  "Central Connecticut": {
    logo: "central_connecticut.png",
    mascots: "Blue Devils",
    endzone_abbreviation: "CCONN",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Blue Devils"],
    alternate_names: [],
  },
  "Central Michigan": {
    logo: "central_michigan.png",
    mascots: "Chippewas",
    endzone_abbreviation: "CMU",
    endzone_hex_color: "6A0032",
    alternate_mascots: ["Lady Chippewas"],
    alternate_names: [],
  },
  "Charleston": {
    logo: "charleston.png",
    mascots: "Cougars",
    endzone_abbreviation: "CHAR",
    endzone_hex_color: "862633",
    alternate_mascots: ["Lady Cougars"],
    alternate_names: [],
  },
  "Charleston Southern": {
    logo: "charleston_southern.png",
    mascots: "Buccaneers",
    endzone_abbreviation: "CSOU",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Buccaneers"],
    alternate_names: [],
  },
  "Charlotte": {
    logo: "charlotte.png",
    mascots: "49ers",
    endzone_abbreviation: "CHAR",
    endzone_hex_color: "00703C",
    alternate_mascots: ["Lady 49ers"],
    alternate_names: [],
  },
  "Chattanooga": {
    logo: "chattanooga.png",
    mascots: "Mocs",
    endzone_abbreviation: "CHAT",
    endzone_hex_color: "00386B",
    alternate_mascots: ["Lady Mocs"],
    alternate_names: [],
  },
  "Chicago State": {
    logo: "chicago_state.png",
    mascots: "Cougars",
    alternate_names: ["Chicago St.", "Chicago St"],
    endzone_abbreviation: "CSU",
    endzone_hex_color: "00563F",
    alternate_mascots: ["Lady Cougars"],
  },
  "Cincinnati": {
    logo: "cincinnati.png",
    mascots: "Bearcats",
    endzone_abbreviation: "CIN",
    endzone_hex_color: "000000",
    alternate_mascots: ["Lady Bearcats"],
    alternate_names: [],
  },
  "Clarkson": {
    logo: "clarkson.png",
    mascots: "Golden Knights",
    endzone_abbreviation: "CLAR",
    endzone_hex_color: "00563F",
    alternate_mascots: ["Lady Golden Knights"],
    alternate_names: [],
  },
  "Clemson": {
    logo: "clemson.png",
    mascots: "Tigers",
    endzone_abbreviation: "CLEM",
    endzone_hex_color: "F66733",
    alternate_mascots: ["Lady Tigers"],
    alternate_names: [],
  },
  "Cleveland State": {
    logo: "cleveland_state.png",
    mascots: "Vikings",
    alternate_names: ["Cleveland St.", "Cleveland St"],
    endzone_abbreviation: "CSU",
    endzone_hex_color: "00543C",
    alternate_mascots: ["Lady Vikings"],
  },
  "Coastal Carolina": {
    logo: "coastal_carolina.png",
    mascots: "Chanticleers",
    endzone_abbreviation: "CCAR",
    endzone_hex_color: "007B4C",
    alternate_mascots: ["Lady Chanticleers"],
    alternate_names: [],
  },
  "Colgate": {
    logo: "colgate.png",
    mascots: "Raiders",
    endzone_abbreviation: "COLG",
    endzone_hex_color: "862633",
    alternate_mascots: ["Lady Raiders"],
    alternate_names: [],
  },
  "Colorado": {
    logo: "colorado.png",
    mascots: "Buffaloes",
    endzone_abbreviation: "COL",
    endzone_hex_color: "CFB87C",
    alternate_mascots: ["Lady Buffaloes"],
    alternate_names: [],
  },
  "Colorado College": {
    logo: "colorado_college.png",
    mascots: "Tigers",
    endzone_abbreviation: "COLC",
    endzone_hex_color: "000000",
    alternate_mascots: ["Lady Tigers"],
    alternate_names: [],
  },
  "Colorado State": {
    logo: "colorado_state.png",
    mascots: "Rams",
    alternate_names: ["Colorado St.", "Colorado St"],
    endzone_abbreviation: "CSU",
    endzone_hex_color: "1E4D2B",
    alternate_mascots: ["Lady Rams"],
  },
  "Columbia": {
    logo: "columbia.png",
    mascots: "Lions",
    endzone_abbreviation: "COLU",
    endzone_hex_color: "003DA5",
    alternate_mascots: ["Lady Lions"],
    alternate_names: [],
  },
  "Coppin State": {
    logo: "coppin_state.png",
    mascots: "Eagles",
    alternate_names: ["Coppin St.", "Coppin St"],
    endzone_abbreviation: "CST",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Eagles"],
  },
  "Cornell": {
    logo: "cornell.png",
    mascots: "Big Red",
    endzone_abbreviation: "CORN",
    endzone_hex_color: "B31B1B",
    alternate_mascots: ["Lady Big Red"],
    alternate_names: [],
  },
  "Creighton": {
    logo: "creighton.png",
    mascots: "Bluejays",
    endzone_abbreviation: "CREI",
    endzone_hex_color: "003DA5",
    alternate_mascots: ["Lady Bluejays"],
    alternate_names: [],
  },
  "Dallas Baptist": {
    logo: "dallas_baptist.png",
    mascots: "Patriots",
    endzone_abbreviation: "DBAP",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Patriots"],
    alternate_names: [],
  },
  "Dartmouth": {
    logo: "dartmouth.png",
    mascots: "Big Green",
    endzone_abbreviation: "DART",
    endzone_hex_color: "00693E",
    alternate_mascots: ["Lady Big Green"],
    alternate_names: [],
  },
  "Davidson": {
    logo: "davidson.png",
    mascots: "Wildcats",
    endzone_abbreviation: "DAV",
    endzone_hex_color: "CE1126",
    alternate_mascots: ["Lady Wildcats"],
    alternate_names: [],
  },
  "Dayton": {
    logo: "dayton.png",
    mascots: "Flyers",
    endzone_abbreviation: "DAY",
    endzone_hex_color: "CE1141",
    alternate_mascots: ["Lady Flyers"],
    alternate_names: [],
  },
  "DePaul": {
    logo: "depaul.png",
    mascots: "Blue Demons",
    endzone_abbreviation: "DEPA",
    endzone_hex_color: "003DA5",
    alternate_mascots: ["Lady Blue Demons"],
    alternate_names: [],
  },
  "Delaware": {
    logo: "delaware.png",
    mascots: "Blue Hens",
    endzone_abbreviation: "DELA",
    endzone_hex_color: "00539F",
    alternate_mascots: ["Lady Blue Hens"],
    alternate_names: [],
  },
  "Delaware State": {
    logo: "delaware_state.png",
    mascots: "Hornets",
    alternate_names: ["Delaware St.", "Delaware St"],
    endzone_abbreviation: "DEST",
    endzone_hex_color: "C8102E",
    alternate_mascots: ["Lady Hornets"],
  },
  "Denver": {
    logo: "denver.png",
    mascots: "Pioneers",
    endzone_abbreviation: "DEN",
    endzone_hex_color: "8B2332",
    alternate_mascots: ["Lady Pioneers"],
    alternate_names: [],
  },
  "Detroit Mercy": {
    logo: "detroit_mercy.png",
    mascots: "Titans",
    endzone_abbreviation: "DET",
    endzone_hex_color: "C8102E",
    alternate_mascots: ["Lady Titans"],
    alternate_names: [],
  },
  "Doane": {
    logo: "doane.png",
    mascots: "Tigers",
    endzone_abbreviation: "DOA",
    endzone_hex_color: "FF6600",
    alternate_mascots: ["Lady Tigers"],
    alternate_names: [],
  },
  "Drake": {
    logo: "drake.png",
    mascots: "Bulldogs",
    endzone_abbreviation: "DRAK",
    endzone_hex_color: "003B71",
    alternate_mascots: ["Lady Bulldogs"],
    alternate_names: [],
  },
  "Drexel": {
    logo: "drexel.png",
    mascots: "Dragons",
    endzone_abbreviation: "DREX",
    endzone_hex_color: "002F6C",
    alternate_mascots: ["Lady Dragons"],
    alternate_names: [],
  },
  "Duke": {
    logo: "duke.png",
    mascots: "Blue Devils",
    endzone_abbreviation: "DUKE",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Blue Devils"],
    alternate_names: [],
  },
  "Duquesne": {
    logo: "duquesne.png",
    mascots: "Dukes",
    endzone_abbreviation: "DUQU",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Dukes"],
    alternate_names: [],
  },
  "ECU": {
    logo: "east_carolina.png",
    mascots: "Pirates",
    alternate_names: ["East Carolina"],
    endzone_abbreviation: "ECU",
    endzone_hex_color: "592A8A",
    alternate_mascots: ["Lady Pirates"],
  },
  "EKU": {
    logo: "eastern_kentucky.png",
    mascots: "Colonels",
    endzone_abbreviation: "EKU",
    endzone_hex_color: "862633",
    alternate_mascots: ["Lady Colonels"],
    alternate_names: [],
  },
  "ETSU": {
    logo: "east_tennessee_state.png",
    mascots: "Buccaneers",
    endzone_abbreviation: "ETSU",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Buccaneers"],
    alternate_names: [],
  },
  "Eastern Illinois": {
    logo: "eastern_illinois.png",
    mascots: "Panthers",
    endzone_abbreviation: "EIL",
    endzone_hex_color: "004B83",
    alternate_mascots: ["Lady Panthers"],
    alternate_names: [],
  },
  "Eastern Michigan": {
    logo: "eastern_michigan.png",
    mascots: "Eagles",
    endzone_abbreviation: "EMI",
    endzone_hex_color: "006633",
    alternate_mascots: ["Lady Eagles"],
    alternate_names: [],
  },
  "Eastern Washington": {
    logo: "eastern_washington.png",
    mascots: "Eagles",
    endzone_abbreviation: "EWAS",
    endzone_hex_color: "A10022",
    alternate_mascots: ["Lady Eagles"],
    alternate_names: [],
  },
  "Elon": {
    logo: "elon.png",
    mascots: "Phoenix",
    endzone_abbreviation: "ELON",
    endzone_hex_color: "872434",
    alternate_mascots: ["Lady Phoenix"],
    alternate_names: [],
  },
  "Evansville": {
    logo: "evansville.png",
    mascots: "Purple Aces",
    endzone_abbreviation: "EVAN",
    endzone_hex_color: "4D1979",
    alternate_mascots: ["Lady Purple Aces"],
    alternate_names: [],
  },
  "FIU": {
    logo: "florida_international.png",
    mascots: "Panthers",
    endzone_abbreviation: "FIU",
    endzone_hex_color: "081E3F",
    alternate_mascots: ["Lady Panthers"],
    alternate_names: [],
  },
  "Fairfield": {
    logo: "fairfield.png",
    mascots: "Stags",
    endzone_abbreviation: "FAIR",
    endzone_hex_color: "CE1126",
    alternate_mascots: ["Lady Stags"],
    alternate_names: [],
  },
  "Fairleigh Dickinson": {
    logo: "fairleigh_dickinson.png",
    mascots: "Knights",
    alternate_names: ["FDU"],
    endzone_abbreviation: "FDU",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Knights"],
  },
  "Ferris State": {
    logo: "ferris_state.png",
    mascots: "Bulldogs",
    alternate_names: ["Ferris St.", "Ferris St"],
    endzone_abbreviation: "FSU",
    endzone_hex_color: "C8102E",
    alternate_mascots: ["Lady Bulldogs"],
  },
  "Florida": {
    logo: "florida.png",
    mascots: "Gators",
    endzone_abbreviation: "FLA",
    endzone_hex_color: "0021A5",
    alternate_mascots: ["Lady Gators"],
    alternate_names: [],
  },
  "Florida A&M": {
    logo: "florida_a_m.png",
    mascots: "Panthers",
    endzone_abbreviation: "FAMU",
    endzone_hex_color: "FF6A00",
    alternate_mascots: ["Lady Panthers"],
    alternate_names: [],
  },
  "Florida Atlantic": {
    logo: "florida.png",
    mascots: "Owls",
    endzone_abbreviation: "FAU",
    endzone_hex_color: "003366",
    alternate_mascots: ["Lady Owls"],
    alternate_names: [],
  },
  "Florida Gulf Coast": {
    logo: "florida_gulf_coast.png",
    mascots: "Eagles",
    endzone_abbreviation: "FGCU",
    endzone_hex_color: "007749",
    alternate_mascots: ["Lady Eagles"],
    alternate_names: [],
  },
  "Florida State": {
    logo: "florida_state.png",
    mascots: "Seminoles",
    alternate_names: ["Florida St.", "Florida St"],
    endzone_abbreviation: "FSU",
    endzone_hex_color: "782F40",
    alternate_mascots: ["Lady Seminoles"],
  },
  "Fordham": {
    logo: "fordham.png",
    mascots: "Rams",
    endzone_abbreviation: "FORD",
    endzone_hex_color: "862633",
    alternate_mascots: ["Lady Rams"],
    alternate_names: [],
  },
  "Fresno State": {
    logo: "fresno_state.png",
    mascots: "Bulldogs",
    alternate_names: ["Fresno St.", "Fresno St"],
    endzone_abbreviation: "FRES",
    endzone_hex_color: "DB0032",
    alternate_mascots: ["Lady Bulldogs"],
  },
  "Furman": {
    logo: "furman.png",
    mascots: "Paladins",
    endzone_abbreviation: "FURM",
    endzone_hex_color: "582C83",
    alternate_mascots: ["Lady Paladins"],
    alternate_names: [],
  },
  "GVSU": {
    logo: "grand_valley_state.png",
    mascots: "Lakers",
    alternate_names: ["Grand Valley State"],
    endzone_abbreviation: "GVSU",
    endzone_hex_color: "0065A4",
    alternate_mascots: ["Lady Lakers"],
  },
  "Gardner-Webb": {
    logo: "gardner_webb.png",
    mascots: "Bulldogs",
    endzone_abbreviation: "GWU",
    endzone_hex_color: "C8102E",
    alternate_mascots: ["Lady Bulldogs"],
    alternate_names: [],
  },
  "George Mason": {
    logo: "george_mason.png",
    mascots: "Patriots",
    endzone_abbreviation: "GMU",
    endzone_hex_color: "006633",
    alternate_mascots: ["Lady Patriots"],
    alternate_names: [],
  },
  "George Washington": {
    logo: "george_washington.png",
    mascots: "Colonials",
    endzone_abbreviation: "GWU",
    endzone_hex_color: "003366",
    alternate_mascots: ["Lady Colonials"],
    alternate_names: [],
  },
  "Georgetown": {
    logo: "georgetown.png",
    mascots: "Hoyas",
    endzone_abbreviation: "GEOR",
    endzone_hex_color: "041E42",
    alternate_mascots: ["Lady Hoyas"],
    alternate_names: [],
  },
  "Georgia": {
    logo: "georgia.png",
    mascots: "Bulldogs",
    alternate_mascots: ["Lady Bulldogs"],
    endzone_abbreviation: "UGA",
    endzone_hex_color: "BA0C2F",
    alternate_names: [],
  },
  "Georgia Southern": {
    logo: "georgia_southern.png",
    mascots: "Eagles",
    endzone_abbreviation: "GS",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Eagles"],
    alternate_names: [],
  },
  "Georgia State": {
    logo: "georgia_state.png",
    mascots: "Panthers",
    alternate_names: ["Georgia St.", "Georgia St"],
    endzone_abbreviation: "GSU",
    endzone_hex_color: "0039A6",
    alternate_mascots: ["Lady Panthers"],
  },
  "Georgia Tech": {
    logo: "georgia_tech.png",
    mascots: "Yellow Jackets",
    endzone_abbreviation: "GT",
    endzone_hex_color: "003057",
    alternate_mascots: ["Lady Yellow Jackets"],
    alternate_names: [],
  },
  "Gonzaga": {
    logo: "gonzaga.png",
    mascots: "Bulldogs",
    endzone_abbreviation: "GONZ",
    endzone_hex_color: "002D62",
    alternate_mascots: ["Lady Bulldogs"],
    alternate_names: [],
  },
  "Grambling State": {
    logo: "grambling_state.png",
    mascots: "Tigers",
    alternate_names: ["Grambling St.", "Grambling St"],
    endzone_abbreviation: "GSU",
    endzone_hex_color: "000000",
    alternate_mascots: ["Lady Tigers"],
  },
  "Grand Canyon": {
    logo: "grand_canyon.png",
    mascots: "Antelopes",
    endzone_abbreviation: "GCU",
    endzone_hex_color: "522D80",
    alternate_mascots: ["Lady Antelopes"],
    alternate_names: [],
  },
  "Hampton": {
    logo: "hampton.png",
    mascots: "Pirates",
    endzone_abbreviation: "HAM",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Pirates"],
    alternate_names: [],
  },
  "Hartford": {
    logo: "hartford.png",
    mascots: "Hawks",
    endzone_abbreviation: "HART",
    endzone_hex_color: "C8102E",
    alternate_mascots: ["Lady Hawks"],
    alternate_names: [],
  },
  "Harvard": {
    logo: "harvard.png",
    mascots: "Crimson",
    endzone_abbreviation: "HARV",
    endzone_hex_color: "A51C30",
    alternate_mascots: ["Lady Crimson"],
    alternate_names: [],
  },
  "Hawaii": {
    logo: "hawaii.png",
    mascots: "Warriors",
    alternate_names: ["Hawai'i"],
    endzone_abbreviation: "HAW",
    endzone_hex_color: "024731",
    alternate_mascots: ["Lady Warriors"],
  },
  "High Point": {
    logo: "high_point.png",
    mascots: "Panthers",
    endzone_abbreviation: "HP",
    endzone_hex_color: "330072",
    alternate_mascots: ["Lady Panthers"],
    alternate_names: [],
  },
  "Hofstra": {
    logo: "hofstra.png",
    mascots: "Pride",
    endzone_abbreviation: "HOF",
    endzone_hex_color: "00467F",
    alternate_mascots: ["Lady Pride"],
    alternate_names: [],
  },
  "Holy Cross": {
    logo: "holy_cross.png",
    mascots: "Crusaders",
    endzone_abbreviation: "HOLY",
    endzone_hex_color: "602D89",
    alternate_mascots: ["Lady Crusaders"],
    alternate_names: [],
  },
  "Houston": {
    logo: "houston.png",
    mascots: "Cougars",
    endzone_abbreviation: "HOU",
    endzone_hex_color: "C8102E",
    alternate_mascots: ["Lady Cougars"],
    alternate_names: [],
  },
  "Houston Christian": {
    logo: "houston_christian.png",
    mascots: "Huskies",
    endzone_abbreviation: "HOUC",
    endzone_hex_color: "273A80",
    alternate_mascots: ["Lady Huskies"],
    alternate_names: [],
  },
  "Howard": {
    logo: "howard.png",
    mascots: "Bison",
    endzone_abbreviation: "HOW",
    endzone_hex_color: "003A63",
    alternate_mascots: ["Lady Bison"],
    alternate_names: [],
  },
  "IUPUI": {
    logo: "iupui.png",
    mascots: "Jaguars",
    endzone_abbreviation: "IUPUI",
    endzone_hex_color: "000000",
    alternate_mascots: ["Lady Jaguars"],
    alternate_names: [],
  },
  "Idaho": {
    logo: "idaho.png",
    mascots: "Vandals",
    endzone_abbreviation: "IDAH",
    endzone_hex_color: "B4975A",
    alternate_mascots: ["Lady Vandals"],
    alternate_names: [],
  },
  "Idaho State": {
    logo: "idaho.png",
    mascots: "Bengals",
    alternate_names: ["Idaho St.", "Idaho St"],
    endzone_abbreviation: "IDST",
    endzone_hex_color: "FF6A00",
    alternate_mascots: ["Lady Bengals"],
  },
  "Illinois": {
    logo: "illinois.png",
    mascots: "Fighting Illini",
    endzone_abbreviation: "ILL",
    endzone_hex_color: "13294B",
    alternate_mascots: ["Lady Fighting Illini"],
    alternate_names: [],
  },
  "Illinois State": {
    logo: "illinois_state.png",
    mascots: "Redbirds",
    alternate_names: ["Illinois St.", "Illinois St"],
    endzone_abbreviation: "ILST",
    endzone_hex_color: "CE1126",
    alternate_mascots: ["Lady Redbirds"],
  },
  "Illinois-Chicago": {
    logo: "illinois_chicago.png",
    mascots: "Flames",
    endzone_abbreviation: "UIC",
    endzone_hex_color: "001E62",
    alternate_mascots: ["Lady Flames"],
    alternate_names: [],
  },
  "Incarnate Word": {
    logo: "incarnate_word.png",
    mascots: "Cardinals",
    endzone_abbreviation: "UIW",
    endzone_hex_color: "A6192E",
    alternate_mascots: ["Lady Cardinals"],
    alternate_names: [],
  },
  "Indiana": {
    logo: "indiana.png",
    mascots: "Hoosiers",
    endzone_abbreviation: "IND",
    endzone_hex_color: "990000",
    alternate_mascots: ["Lady Hoosiers"],
    alternate_names: [],
  },
  "Indiana State": {
    logo: "indiana_state.png",
    mascots: "Sycamores",
    alternate_names: ["Indiana St.", "Indiana St"],
    endzone_abbreviation: "INST",
    endzone_hex_color: "003DA5",
    alternate_mascots: ["Lady Sycamores"],
  },
  "Iona": {
    logo: "iona.png",
    mascots: "Gaels",
    endzone_abbreviation: "IONA",
    endzone_hex_color: "862633",
    alternate_mascots: ["Lady Gaels"],
    alternate_names: [],
  },
  "Iowa": {
    logo: "iowa.png",
    mascots: "Hawkeyes",
    alternate_names: ["Iowa Hawkeyes"],
    endzone_abbreviation: "IOWA",
    endzone_hex_color: "000000",
    alternate_mascots: ["Lady Hawkeyes"],
  },
  "Iowa State": {
    logo: "iowa_state.png",
    mascots: "Cyclones",
    alternate_names: ["Iowa St.", "Iowa St"],
    endzone_abbreviation: "ISU",
    endzone_hex_color: "C8102E",
    alternate_mascots: ["Lady Cyclones"],
  },
  "Jackson State": {
    logo: "jackson_state.png",
    mascots: "Tigers",
    alternate_names: ["Jackson St.", "Jackson St"],
    endzone_abbreviation: "JSU",
    endzone_hex_color: "004685",
    alternate_mascots: ["Lady Tigers"],
  },
  "Jacksonville": {
    logo: "jacksonville.png",
    mascots: "Dolphins",
    endzone_abbreviation: "JU",
    endzone_hex_color: "005B5D",
    alternate_mascots: ["Lady Dolphins"],
    alternate_names: [],
  },
  "Jacksonville State": {
    logo: "jacksonville_state.png",
    mascots: "Gamecocks",
    alternate_names: ["Jacksonville St.", "Jacksonville St"],
    endzone_abbreviation: "JSU",
    endzone_hex_color: "DC143C",
    alternate_mascots: ["Lady Gamecocks"],
  },
  "James Madison": {
    logo: "james_madison.png",
    mascots: "Dukes",
    endzone_abbreviation: "JMU",
    endzone_hex_color: "450084",
    alternate_mascots: ["Lady Dukes"],
    alternate_names: [],
  },
  "Kansas": {
    logo: "kansas.png",
    mascots: "Jayhawks",
    endzone_abbreviation: "KAN",
    endzone_hex_color: "0051BA",
    alternate_mascots: ["Lady Jayhawks"],
    alternate_names: [],
  },
  "Kansas City": {
    logo: "missouri_kansas_city.png",
    mascots: "Roos",
    endzone_abbreviation: "UMKC",
    endzone_hex_color: "F1BE48",
    alternate_mascots: ["Lady Roos"],
    alternate_names: [],
  },
  "Kansas State": {
    logo: "kansas_state.png",
    mascots: "Wildcats",
    alternate_names: ["Kansas St.", "Kansas St", "K-State"],
    endzone_abbreviation: "KSU",
    endzone_hex_color: "512888",
    alternate_mascots: ["Lady Wildcats"],
  },
  "Kearney": {
    logo: "kearney.png",
    mascots: "Lopers",
    endzone_abbreviation: "UNK",
    endzone_hex_color: "003D7A",
    alternate_mascots: ["Lady Lopers"],
    alternate_names: [],
  },
  "Kennesaw State": {
    logo: "kennesaw_state.png",
    mascots: "Owls",
    alternate_names: ["Kennesaw St.", "Kennesaw St"],
    endzone_abbreviation: "KSU",
    endzone_hex_color: "FFB500",
    alternate_mascots: ["Lady Owls"],
  },
  "Kent State": {
    logo: "kent_state.png",
    mascots: "Golden Flashes",
    alternate_names: ["Kent St.", "Kent St"],
    endzone_abbreviation: "KENT",
    endzone_hex_color: "002664",
    alternate_mascots: ["Lady Golden Flashes"],
  },
  "Kentucky": {
    logo: "kentucky.png",
    mascots: "Wildcats",
    endzone_abbreviation: "KENT",
    endzone_hex_color: "0033A0",
    alternate_mascots: ["Lady Wildcats"],
    alternate_names: [],
  },
  "LIU": {
    logo: "long_island.png",
    mascots: "Sharks",
    endzone_abbreviation: "LIU",
    alternate_names: ["Long Island"],
    endzone_hex_color: "003A70",
    alternate_mascots: ["Lady Sharks"],
  },
  "LSU": {
    logo: "louisiana_state.png",
    mascots: "Tigers",
    alternate_mascots: ["Lady Tigers"],
    endzone_abbreviation: "LSU",
    endzone_hex_color: "461D7C",
    alternate_names: [],
  },
  "La Salle": {
    logo: "la_salle.png",
    mascots: "Explorers",
    endzone_abbreviation: "LAS",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Explorers"],
    alternate_names: [],
  },
  "Lafayette": {
    logo: "lafayette.png",
    mascots: "Leopards",
    endzone_abbreviation: "LAF",
    endzone_hex_color: "8B0000",
    alternate_mascots: ["Lady Leopards"],
    alternate_names: [],
  },
  "Lake Superior State": {
    logo: "lake_superior_state.png",
    mascots: "Lakers",
    alternate_names: ["Lake Superior St.", "Lake Superior St"],
    endzone_abbreviation: "LSSU",
    endzone_hex_color: "003F87",
    alternate_mascots: ["Lady Lakers"],
  },
  "Lamar": {
    logo: "lamar.png",
    mascots: "Cardinals",
    endzone_abbreviation: "LAM",
    endzone_hex_color: "C8102E",
    alternate_mascots: ["Lady Cardinals"],
    alternate_names: [],
  },
  "Le Moyne": {
    logo: "le_moyne.png",
    mascots: "Dolphins",
    endzone_abbreviation: "LEMO",
    endzone_hex_color: "006B3F",
    alternate_mascots: ["Lady Dolphins"],
    alternate_names: [],
  },
  "Lehigh": {
    logo: "lehigh.png",
    mascots: "Hawks",
    endzone_abbreviation: "LEHI",
    endzone_hex_color: "653B26",
    alternate_mascots: ["Lady Hawks"],
    alternate_names: [],
  },
  "Liberty": {
    logo: "liberty.png",
    mascots: "Flames",
    endzone_abbreviation: "LIB",
    endzone_hex_color: "002147",
    alternate_mascots: ["Lady Flames"],
    alternate_names: [],
  },
  "Lindenwood": {
    logo: "lindenwood.png",
    mascots: "Lions",
    endzone_abbreviation: "LIND",
    endzone_hex_color: "000000",
    alternate_mascots: ["Lady Lions"],
    alternate_names: [],
  },
  "Lipscomb": {
    logo: "lipscomb.png",
    mascots: "Bisons",
    endzone_abbreviation: "LIP",
    endzone_hex_color: "291C57",
    alternate_mascots: ["Lady Bisons"],
    alternate_names: [],
  },
  "Little Rock": {
    logo: "little_rock.png",
    mascots: "Trojans",
    endzone_abbreviation: "LR",
    endzone_hex_color: "8B0015",
    alternate_mascots: ["Lady Trojans"],
    alternate_names: [],
  },
  "Long Beach State": {
    logo: "long_beach_state.png",
    mascots: "49ers",
    alternate_names: ["Long Beach St.", "Long Beach St"],
    endzone_abbreviation: "LBSU",
    endzone_hex_color: "000000",
    alternate_mascots: ["Lady 49ers"],
  },
  "Longwood": {
    logo: "longwood.png",
    mascots: "Lancers",
    endzone_abbreviation: "LW",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Lancers"],
    alternate_names: [],
  },
  "Louisiana": {
    logo: "louisiana.png",
    mascots: "Rajin' Cajuns",
    endzone_abbreviation: "LA",
    endzone_hex_color: "CE181E",
    alternate_mascots: ["Lady Rajin' Cajuns"],
    alternate_names: [],
  },
  "Louisiana Tech": {
    logo: "louisiana_tech.png",
    mascots: "Bulldogs",
    endzone_abbreviation: "LATECH",
    endzone_hex_color: "002D62",
    alternate_mascots: ["Lady Bulldogs"],
    alternate_names: [],
  },
  "Louisiana-Monroe": {
    logo: "louisiana_monroe.png",
    mascots: "Warhawks",
    endzone_abbreviation: "ULM",
    endzone_hex_color: "8B0015",
    alternate_mascots: ["Lady Warhawks"],
    alternate_names: [],
  },
  "Louisville": {
    logo: "louisville.png",
    mascots: "Cardinals",
    endzone_abbreviation: "UL",
    endzone_hex_color: "AD0000",
    alternate_mascots: ["Lady Cardinals"],
    alternate_names: [],
  },
  "Loyola": {
    logo: "loyola.png",
    mascots: "Ramblers",
    endzone_abbreviation: "LOY",
    endzone_hex_color: "862633",
    alternate_mascots: ["Lady Ramblers"],
    alternate_names: [],
  },
  "Loyola Marymount": {
    logo: "loyola_marymount.png",
    mascots: "Lions",
    endzone_abbreviation: "LMU",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Lions"],
    alternate_names: [],
  },
  "Loyola-Maryland": {
    logo: "loyola_maryland.png",
    mascots: "Greyhounds",
    endzone_abbreviation: "LOYMD",
    endzone_hex_color: "006747",
    alternate_mascots: ["Lady Greyhounds"],
    alternate_names: [],
  },
  "MVSU": {
    logo: "mississippi_valley_state.png",
    mascots: "Delta Devils",
    endzone_abbreviation: "MVSU",
    endzone_hex_color: "006747",
    alternate_mascots: ["Lady Delta Devils"],
    alternate_names: [],
  },
  "Maine": {
    logo: "maine.png",
    mascots: "Black Bears",
    endzone_abbreviation: "MAINE",
    endzone_hex_color: "003263",
    alternate_mascots: ["Lady Black Bears"],
    alternate_names: [],
  },
  "Manhattan": {
    logo: "manhattan.png",
    mascots: "Jaspers",
    endzone_abbreviation: "MANH",
    endzone_hex_color: "006B3F",
    alternate_mascots: ["Lady Jaspers"],
    alternate_names: [],
  },
  "Marist": {
    logo: "marist.png",
    mascots: "Red Foxes",
    endzone_abbreviation: "MAR",
    endzone_hex_color: "C8102E",
    alternate_mascots: ["Lady Red Foxes"],
    alternate_names: [],
  },
  "Marquette": {
    logo: "marquette.png",
    mascots: "Golden Eagles",
    endzone_abbreviation: "MARQ",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Golden Eagles"],
    alternate_names: [],
  },
  "Marshall": {
    logo: "marshall.png",
    mascots: "Thundering Herd",
    endzone_abbreviation: "MARSH",
    endzone_hex_color: "00B140",
    alternate_mascots: ["Lady Thundering Herd"],
    alternate_names: [],
  },
  "Maryland": {
    logo: "maryland.png",
    mascots: "Terrapins",
    endzone_abbreviation: "MARY",
    endzone_hex_color: "E21833",
    alternate_mascots: ["Lady Terrapins"],
    alternate_names: [],
  },
  "Maryland-Eastern Shore": {
    logo: "maryland_eastern_shore.png",
    mascots: "Hawks",
    alternate_names: ["UMES"],
    endzone_abbreviation: "MDES",
    endzone_hex_color: "862633",
    alternate_mascots: ["Lady Hawks"],
  },
  "Massachusetts": {
    logo: "massachusetts.png",
    mascots: "Minutemen",
    endzone_abbreviation: "UMASS",
    endzone_hex_color: "881C1C",
    alternate_mascots: ["Lady Minutemen"],
    alternate_names: [],
  },
  "McNeese State": {
    logo: "mcneese_state.png",
    mascots: "Cowboys",
    alternate_names: ["McNeese St.", "McNeese St"],
    endzone_abbreviation: "MCNST",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Cowboys"],
  },
  "Memphis": {
    logo: "memphis.png",
    mascots: "Tigers",
    endzone_abbreviation: "MEM",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Tigers"],
    alternate_names: [],
  },
  "Mercer": {
    logo: "mercer.png",
    mascots: "Bears",
    endzone_abbreviation: "MERC",
    endzone_hex_color: "FF5F00",
    alternate_mascots: ["Lady Bears"],
    alternate_names: [],
  },
  "Mercyhurst": {
    logo: "mercyhurst.png",
    mascots: "Lakers",
    endzone_abbreviation: "MERH",
    endzone_hex_color: "006747",
    alternate_mascots: ["Lady Lakers"],
    alternate_names: [],
  },
  "Merrimack": {
    logo: "merrimack.png",
    mascots: "Warriors",
    endzone_abbreviation: "MERR",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Warriors"],
    alternate_names: [],
  },
  "Miami": {
    logo: "miami.png",
    mascots: "Hurricanes",
    alternate_names: ["Miami (FL)"],
    endzone_abbreviation: "MIA",
    endzone_hex_color: "F47321",
    alternate_mascots: ["Lady Hurricanes"],
  },
  "Miami OH": {
    logo: "miami_ohio.png",
    mascots: "Redhawks",
    alternate_names: ["Miami-OH", "Miami (OH)"],
    endzone_abbreviation: "MIAOH",
    endzone_hex_color: "C8102E",
    alternate_mascots: ["Lady Redhawks"],
  },
  "Michigan": {
    logo: "michigan.png",
    mascots: "Wolverines",
    endzone_abbreviation: "MICH",
    endzone_hex_color: "00274C",
    alternate_mascots: ["Lady Wolverines"],
    alternate_names: [],
  },
  "Michigan State": {
    logo: "michigan_state.png",
    mascots: "Spartans",
    alternate_names: ["Michigan St.", "Michigan St"],
    endzone_abbreviation: "MSU",
    endzone_hex_color: "18453B",
    alternate_mascots: ["Lady Spartans"],
  },
  "Michigan Tech": {
    logo: "michigan_tech.png",
    mascots: "Huskies",
    endzone_abbreviation: "MITECH",
    endzone_hex_color: "FFB500",
    alternate_mascots: ["Lady Huskies"],
    alternate_names: [],
  },
  "Middle Tennessee": {
    logo: "middle_tennessee.png",
    mascots: "Blue Raiders",
    endzone_abbreviation: "MTSU",
    endzone_hex_color: "0066CC",
    alternate_mascots: ["Lady Blue Raiders"],
    alternate_names: [],
  },
  "Midland University": {
    logo: "midland.png",
    mascots: "Warriors",
    alternate_names: ["Midland"],
    endzone_abbreviation: "MID",
    endzone_hex_color: "FF6A00",
    alternate_mascots: ["Lady Warriors"],
  },
  "Minnesota": {
    logo: "minnesota.png",
    mascots: "Golden Gophers",
    endzone_abbreviation: "MINN",
    endzone_hex_color: "7A0019",
    alternate_mascots: ["Lady Golden Gophers"],
    alternate_names: [],
  },
  "Minnesota State": {
    logo: "minnesota_state.png",
    mascots: "Mavericks",
    alternate_names: ["Minnesota St.", "Minnesota St"],
    endzone_abbreviation: "MNSU",
    endzone_hex_color: "592C82",
    alternate_mascots: ["Lady Mavericks"],
  },
  "Minnesota-Duluth": {
    logo: "minnesota_duluth.png",
    mascots: "Bulldogs",
    endzone_abbreviation: "UMD",
    endzone_hex_color: "862633",
    alternate_mascots: ["Lady Bulldogs"],
    alternate_names: [],
  },
  "Mississippi State": {
    logo: "mississippi_state.png",
    mascots: "Bulldogs",
    alternate_names: ["Mississippi St.", "Mississippi St"],
    endzone_abbreviation: "MSU",
    endzone_hex_color: "660000",
    alternate_mascots: ["Lady Bulldogs"],
  },
  "Missouri": {
    logo: "missouri.png",
    mascots: "Tigers",
    endzone_abbreviation: "MIZZ",
    endzone_hex_color: "F1B82D",
    alternate_mascots: ["Lady Tigers"],
    alternate_names: [],
  },
  "Missouri KC": {
    logo: "missouri_kansas_city.png",
    mascots: "Roos",
    endzone_abbreviation: "UMKC",
    endzone_hex_color: "F1BE48",
    alternate_mascots: ["Lady Roos"],
    alternate_names: [],
  },
  "Missouri State": {
    logo: "missouri_state.png",
    mascots: "Bears",
    alternate_names: ["Missouri St.", "Missouri St"],
    endzone_abbreviation: "MIZZST",
    endzone_hex_color: "5E0000",
    alternate_mascots: ["Lady Bears"],
  },
  "Monmouth": {
    logo: "monmouth.png",
    mascots: "Hawks",
    endzone_abbreviation: "MONM",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Hawks"],
    alternate_names: [],
  },
  "Montana": {
    logo: "montana.png",
    mascots: "Grizzlies",
    endzone_abbreviation: "MONT",
    endzone_hex_color: "660000",
    alternate_mascots: ["Lady Grizzlies"],
    alternate_names: [],
  },
  "Montana State": {
    logo: "montana_state.png",
    mascots: "Bobcats",
    alternate_names: ["Montana St.", "Montana St"],
    endzone_abbreviation: "MST",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Bobcats"],
  },
  "Morehead State": {
    logo: "morehead_state.png",
    mascots: "Eagles",
    alternate_names: ["Morehead St.", "Morehead St"],
    endzone_abbreviation: "MORE",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Eagles"],
  },
  "Morgan State": {
    logo: "morgan_state.png",
    mascots: "Bears",
    alternate_names: ["Morgan St.", "Morgan St"],
    endzone_abbreviation: "MORG",
    endzone_hex_color: "FF6A00",
    alternate_mascots: ["Lady Bears"],
  },
  "Mount Marty": {
    logo: "mount_marty.png",
    mascots: "Lancers",
    endzone_abbreviation: "MM",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Lancers"],
    alternate_names: [],
  },
  "Mount St. Mary's": {
    logo: "mount_st_marys.png",
    mascots: "Mountaineers",
    endzone_abbreviation: "MSM",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Mountaineers"],
    alternate_names: ["Mt. St. Mary's", "Mt St. Mary's"],
  },
  "Murray State": {
    logo: "murray_state.png",
    mascots: "Racers",
    alternate_names: ["Murray St.", "Murray St"],
    endzone_abbreviation: "MURR",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Racers"],
  },
  "NC A&T": {
    logo: "north_carolina_agriculture_tech.png",
    mascots: "Aggies",
    endzone_abbreviation: "NCAT",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Aggies"],
    alternate_names: ["North Carolina A&T"],
  },
  "NC Central": {
    logo: "north_carolina_central.png",
    mascots: "Eagles",
    endzone_abbreviation: "NCCU",
    endzone_hex_color: "862633",
    alternate_mascots: ["Lady Eagles"],
    alternate_names: [],
  },
  "NC State": {
    logo: "north_carolina_state.png",
    mascots: "Wolfpack",
    alternate_names: ["NC St.", "NC St", "North Carolina State"],
    endzone_abbreviation: "NCSU",
    endzone_hex_color: "CC0000",
    alternate_mascots: ["Lady Wolfpack"],
  },
  "NIU": {
    logo: "northern_illinois.png",
    mascots: "Huskies",
    endzone_abbreviation: "NIU",
    endzone_hex_color: "BA0C2F",
    alternate_mascots: ["Lady Huskies"],
    alternate_names: [],
  },
  "NJIT": {
    logo: "new_jersey_technology.png",
    mascots: "Highlanders",
    endzone_abbreviation: "NJIT",
    endzone_hex_color: "C8102E",
    alternate_mascots: ["Lady Highlanders"],
    alternate_names: [],
  },
  "Navy": {
    logo: "navy.png",
    mascots: "Midshipmen",
    endzone_abbreviation: "NAVY",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Midshipmen"],
    alternate_names: [],
  },
  "Nebraska": {
    logo: "nebraska.png",
    mascots: "Cornhuskers",
    alternate_names: ["Nebraska Huskers", "Nebraska Cornhuskers"],
    endzone_abbreviation: "NEB",
    endzone_hex_color: "D00000",
    alternate_mascots: ["Lady Cornhuskers"],
  },
  "Nevada": {
    logo: "nevada.png",
    mascots: "Wolf Pack",
    endzone_abbreviation: "NEV",
    endzone_hex_color: "003366",
    alternate_mascots: ["Lady Wolf Pack"],
    alternate_names: [],
  },
  "New Hampshire": {
    logo: "new_hampshire.png",
    mascots: "Wildcats",
    endzone_abbreviation: "UNH",
    endzone_hex_color: "003B71",
    alternate_mascots: ["Lady Wildcats"],
    alternate_names: [],
  },
  "New Haven": {
    logo: "new_haven.png",
    mascots: "Chargers",
    endzone_abbreviation: "NHCT",
    endzone_hex_color: "041E42",
    alternate_mascots: ["Lady Chargers"],
    alternate_names: [],
  },
  "New Mexico": {
    logo: "new_mexico.png",
    mascots: "Lobos",
    endzone_abbreviation: "UNM",
    endzone_hex_color: "BA0C2F",
    alternate_mascots: ["Lady Lobos"],
    alternate_names: [],
  },
  "New Mexico State": {
    logo: "new_mexico_state.png",
    mascots: "Aggies",
    alternate_names: ["New Mexico St.", "New Mexico St"],
    endzone_abbreviation: "NMSU",
    endzone_hex_color: "A6192E",
    alternate_mascots: ["Lady Aggies"],
  },
  "New Orleans": {
    logo: "new_orleans.png",
    mascots: "Privateers",
    endzone_abbreviation: "UNO",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Privateers"],
    alternate_names: [],
  },
  "Niagara": {
    logo: "niagara.png",
    mascots: "Purple Eagles",
    endzone_abbreviation: "NIA",
    endzone_hex_color: "582C83",
    alternate_mascots: ["Lady Purple Eagles"],
    alternate_names: [],
  },
  "Nicholls State": {
    logo: "nicholls_state.png",
    mascots: "Colonels",
    alternate_names: ["Nicholls St.", "Nicholls St"],
    endzone_abbreviation: "NICH",
    endzone_hex_color: "CC0000",
    alternate_mascots: ["Lady Colonels"],
  },
  "Norfolk State": {
    logo: "norfolk_state.png",
    mascots: "Spartans",
    alternate_names: ["Norfolk St.", "Norfolk St"],
    endzone_abbreviation: "NSU",
    endzone_hex_color: "006747",
    alternate_mascots: ["Lady Spartans"],
  },
  "North Alabama": {
    logo: "north_alabama.png",
    mascots: "Lions",
    endzone_abbreviation: "UNA",
    endzone_hex_color: "461D7C",
    alternate_mascots: ["Lady Lions"],
    alternate_names: [],
  },
  "North Carolina": {
    logo: "north_carolina.png",
    mascots: "Tar Heels",
    endzone_abbreviation: "UNC",
    endzone_hex_color: "7BAFD4",
    alternate_mascots: ["Lady Tar Heels"],
    alternate_names: [],
  },
  "North Dakota": {
    logo: "north_dakota.png",
    mascots: "Fighting Hawks",
    endzone_abbreviation: "UND",
    endzone_hex_color: "009A44",
    alternate_mascots: ["Lady Fighting Hawks"],
    alternate_names: [],
  },
  "North Dakota State": {
    logo: "north_dakota_state.png",
    mascots: "Bison",
    alternate_names: ["North Dakota St.", "North Dakota St"],
    endzone_abbreviation: "NDSU",
    endzone_hex_color: "005C3A",
    alternate_mascots: ["Lady Bison"],
  },
  "North Florida": {
    logo: "north_florida.png",
    mascots: "Ospreys",
    endzone_abbreviation: "NF",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Ospreys"],
    alternate_names: [],
  },
  "North Texas": {
    logo: "north_texas.png",
    mascots: "Mean Green",
    endzone_abbreviation: "NT",
    endzone_hex_color: "00853E",
    alternate_mascots: ["Lady Mean Green"],
    alternate_names: [],
  },
  "Northeastern": {
    logo: "northeastern.png",
    mascots: "Huskies",
    endzone_abbreviation: "NE",
    endzone_hex_color: "C8102E",
    alternate_mascots: ["Lady Huskies"],
    alternate_names: [],
  },
  "Northern Arizona": {
    logo: "northern_arizona.png",
    mascots: "Lumberjacks",
    endzone_abbreviation: "NAU",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Lumberjacks"],
    alternate_names: [],
  },
  "Northern Colorado": {
    logo: "northern_colorado.png",
    mascots: "Bears",
    alternate_names: ["Northern Colo."],
    endzone_abbreviation: "NCO",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Bears"],
  },
  "Northern Iowa": {
    logo: "northern_iowa.png",
    mascots: "Panthers",
    endzone_abbreviation: "UNI",
    endzone_hex_color: "4B116F",
    alternate_mascots: ["Lady Panthers"],
    alternate_names: [],
  },
  "Northern Kentucky": {
    logo: "northern_kentucky.png",
    mascots: "Norse",
    endzone_abbreviation: "NKU",
    endzone_hex_color: "FFC425",
    alternate_mascots: ["Lady Norse"],
    alternate_names: [],
  },
  "Northern Michigan": {
    logo: "northern_michigan.png",
    mascots: "Wildcats",
    endzone_abbreviation: "NMU",
    endzone_hex_color: "006747",
    alternate_mascots: ["Lady Wildcats"],
    alternate_names: [],
  },
  "Northwestern": {
    logo: "northwestern.png",
    mascots: "Wildcats",
    endzone_abbreviation: "NW",
    endzone_hex_color: "4F2582",
    alternate_names: ["Northwestern University"],
    alternate_mascots: ["Lady Wildcats"],
  },
  "Northwestern State": {
    logo: "northwestern_state.png",
    mascots: "Demons",
    alternate_names: ["Northwestern St.", "Northwestern St"],
    endzone_abbreviation: "NSU",
    endzone_hex_color: "582C83",
    alternate_mascots: ["Lady Demons"],
  },
  "Notre Dame": {
    logo: "notre_dame.png",
    mascots: "Fighting Irish",
    endzone_abbreviation: "ND",
    endzone_hex_color: "0C2340",
    alternate_mascots: ["Lady Fighting Irish"],
    alternate_names: [],
  },
  "Oakland": {
    logo: "oakland.png",
    mascots: "Golden Grizzlies",
    endzone_abbreviation: "OU",
    endzone_hex_color: "867045",
    alternate_mascots: ["Lady Golden Grizzlies"],
    alternate_names: [],
  },
  "Ohio": {
    logo: "ohio.png",
    mascots: "Bobcats",
    endzone_abbreviation: "OHIO",
    endzone_hex_color: "00694E",
    alternate_mascots: ["Lady Bobcats"],
    alternate_names: [],
  },
  "Ohio State": {
    logo: "ohio_state.png",
    mascots: "Buckeyes",
    alternate_names: ["Ohio St.", "Ohio St"],
    endzone_abbreviation: "OSU",
    endzone_hex_color: "BB0000",
    alternate_mascots: ["Lady Buckeyes"],
  },
  "Oklahoma": {
    logo: "oklahoma.png",
    mascots: "Sooners",
    endzone_abbreviation: "OKLA",
    endzone_hex_color: "841617",
    alternate_mascots: ["Lady Sooners"],
    alternate_names: [],
  },
  "Oklahoma State": {
    logo: "oklahoma_state.png",
    mascots: "Cowboys",
    alternate_names: ["Oklahoma St.", "Oklahoma St"],
    endzone_abbreviation: "OSU",
    endzone_hex_color: "FF6A00",
    alternate_mascots: ["Lady Cowboys", "Cowgirls"],
  },
  "Old Dominion": {
    logo: "old_dominion.png",
    mascots: "Monarchs",
    endzone_abbreviation: "ODU",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Monarchs"],
    alternate_names: [],
  },
  "Ole Miss": {
    logo: "mississippi.png",
    mascots: "Rebels",
    endzone_abbreviation: "MISS",
    endzone_hex_color: "14213D",
    alternate_mascots: ["Lady Rebels"],
    alternate_names: [],
  },
  "Omaha": {
    logo: "omaha.png",
    mascots: "Mavericks",
    endzone_abbreviation: "OMA",
    endzone_hex_color: "BA0C2F",
    alternate_mascots: ["Lady Mavericks"],
    alternate_names: [],
  },
  "Oral Roberts": {
    logo: "oral_roberts.png",
    mascots: "Golden Eagles",
    endzone_abbreviation: "ORU",
    endzone_hex_color: "002D62",
    alternate_mascots: ["Lady Golden Eagles"],
    alternate_names: [],
  },
  "Oregon": {
    logo: "oregon.png",
    mascots: "Ducks",
    endzone_abbreviation: "ORE",
    endzone_hex_color: "154733",
    alternate_mascots: ["Lady Ducks"],
    alternate_names: [],
  },
  "Oregon State": {
    logo: "oregon_state.png",
    mascots: "Beavers",
    alternate_names: ["Oregon St.", "Oregon St"],
    endzone_abbreviation: "OSU",
    endzone_hex_color: "DC4405",
    alternate_mascots: ["Lady Beavers"],
  },
  "Pacific": {
    logo: "pacific.png",
    mascots: "Tigers",
    endzone_abbreviation: "PAC",
    endzone_hex_color: "FF6A00",
    alternate_mascots: ["Lady Tigers"],
    alternate_names: [],
  },
  "Penn": {
    logo: "pennsylvania.png",
    mascots: "Quakers",
    endzone_abbreviation: "PENN",
    endzone_hex_color: "011F5B",
    alternate_mascots: ["Lady Quakers"],
    alternate_names: [],
  },
  "Penn State": {
    logo: "pennsylvania_state.png",
    mascots: "Nittany Lions",
    alternate_names: ["Penn St.", "Penn St"],
    endzone_abbreviation: "PSU",
    endzone_hex_color: "1E407C",
    alternate_mascots: ["Lady Nittany Lions"],
  },
  "Pepperdine": {
    logo: "pepperdine.png",
    mascots: "Waves",
    endzone_abbreviation: "PEPP",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Waves"],
    alternate_names: [],
  },
  "Peru State": {
    logo: "peru_state.png",
    mascots: "Bobcats",
    endzone_abbreviation: "PERU",
    alternate_names: ["Peru St.", "Peru St"],
    endzone_hex_color: "C8102E",
    alternate_mascots: ["Lady Bobcats"],
  },
  "Pittsburgh": {
    logo: "pittsburgh.png",
    mascots: "Panthers",
    endzone_abbreviation: "PITT",
    endzone_hex_color: "003594",
    alternate_mascots: ["Lady Panthers"],
    alternate_names: [],
  },
  "Portland": {
    logo: "portland.png",
    mascots: "Pilots",
    endzone_abbreviation: "PORT",
    endzone_hex_color: "582C83",
    alternate_mascots: ["Lady Pilots"],
    alternate_names: [],
  },
  "Portland State": {
    logo: "portland_state.png",
    mascots: "Vikings",
    alternate_names: ["Portland St.", "Portland St"],
    endzone_abbreviation: "PSU",
    endzone_hex_color: "00563F",
    alternate_mascots: ["Lady Vikings"],
  },
  "Prairie View A&M": {
    logo: "prairie_view_a_m.png",
    mascots: "Panthers",
    endzone_abbreviation: "PVAMU",
    endzone_hex_color: "4F2170",
    alternate_mascots: ["Lady Panthers"],
    alternate_names: [],
  },
  "Presbyterian": {
    logo: "presbyterian.png",
    mascots: "Blue Hose",
    endzone_abbreviation: "PRES",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Blue Hose"],
    alternate_names: [],
  },
  "Princeton": {
    logo: "princeton.png",
    mascots: "Tigers",
    endzone_abbreviation: "PRIN",
    endzone_hex_color: "FF6A00",
    alternate_mascots: ["Lady Tigers"],
    alternate_names: [],
  },
  "Providence": {
    logo: "providence.png",
    mascots: "Friars",
    endzone_abbreviation: "PROV",
    endzone_hex_color: "000000",
    alternate_mascots: ["Lady Friars"],
    alternate_names: [],
  },
  "Purdue": {
    logo: "purdue.png",
    mascots: "Boilermakers",
    endzone_abbreviation: "PUR",
    endzone_hex_color: "C28E0E",
    alternate_mascots: ["Lady Boilermakers"],
    alternate_names: [],
  },
  "Purdue Fort Wayne": {
    logo: "purdue_fort_wayne.png",
    mascots: "Mastodons",
    alternate_names: ["Purdue University Fort Wayne"],
    endzone_abbreviation: "PFW",
    endzone_hex_color: "003B5C",
    alternate_mascots: ["Lady Mastodons"],
  },
  "Queens": {
    logo: "queens.png",
    mascots: "Royals",
    endzone_abbreviation: "QUE",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Royals"],
    alternate_names: [],
  },
  "Quinnipiac": {
    logo: "quinnipiac.png",
    mascots: "Bobcats",
    endzone_abbreviation: "QUIN",
    endzone_hex_color: "002147",
    alternate_mascots: ["Lady Bobcats"],
    alternate_names: [],
  },
  "RIT": {
    logo: "rochester_technology.png",
    mascots: "Tigers",
    endzone_abbreviation: "RIT",
    endzone_hex_color: "F76902",
    alternate_mascots: ["Lady Tigers"],
    alternate_names: [],
  },
  "RPI": {
    logo: "rensseleaer_polytechnic.png",
    mascots: "Engineers",
    endzone_abbreviation: "RPI",
    endzone_hex_color: "DA291C",
    alternate_mascots: ["Lady Engineers"],
    alternate_names: [],
  },
  "Radford": {
    logo: "radford.png",
    mascots: "Highlanders",
    endzone_abbreviation: "RAD",
    endzone_hex_color: "CE1126",
    alternate_mascots: ["Lady Highlanders"],
    alternate_names: [],
  },
  "Rhode Island": {
    logo: "rhode_island.png",
    mascots: "Rams",
    endzone_abbreviation: "URI",
    endzone_hex_color: "003DA5",
    alternate_mascots: ["Lady Rams"],
    alternate_names: [],
  },
  "Rice": {
    logo: "rice.png",
    mascots: "Owls",
    endzone_abbreviation: "RICE",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Owls"],
    alternate_names: [],
  },
  "Richmond": {
    logo: "richmond.png",
    mascots: "Spiders",
    endzone_abbreviation: "RICH",
    endzone_hex_color: "002F5F",
    alternate_mascots: ["Lady Spiders"],
    alternate_names: [],
  },
  "Rider": {
    logo: "rider.png",
    mascots: "Broncs",
    endzone_abbreviation: "RIDER",
    endzone_hex_color: "862633",
    alternate_mascots: ["Lady Broncs"],
    alternate_names: [],
  },
  "Robert Morris": {
    logo: "robert_morris.png",
    mascots: "Colonials",
    endzone_abbreviation: "RMU",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Colonials"],
    alternate_names: [],
  },
  "Rutgers": {
    logo: "rutgers.png",
    mascots: "Scarlet Knights",
    endzone_abbreviation: "RUTG",
    endzone_hex_color: "CC0033",
    alternate_mascots: ["Lady Scarlet Knights"],
    alternate_names: [],
  },
  "SE Louisiana": {
    logo: "southeastern_louisiana.png",
    mascots: "Lions",
    alternate_names: ["Southeastern Louisiana", "Southeastern La"],
    endzone_abbreviation: "SELA",
    endzone_hex_color: "006B3F",
    alternate_mascots: ["Lady Lions"],
  },
  "SEMO": {
    logo: "southeast_missouri_state.png",
    mascots: "Redhawks",
    endzone_abbreviation: "SEMO",
    endzone_hex_color: "C8102E",
    alternate_mascots: ["Lady Redhawks"],
    alternate_names: [],
  },
  "SIUE": {
    logo: "southern_illinois_edwardsville.png",
    mascots: "Cougars",
    endzone_abbreviation: "SIUE",
    endzone_hex_color: "C8102E",
    alternate_mascots: ["Lady Cougars"],
    alternate_names: [],
  },
  "SMU": {
    logo: "southern_methodist.png",
    mascots: "Mustangs",
    endzone_abbreviation: "SMU",
    endzone_hex_color: "CC0035",
    alternate_mascots: ["Lady Mustangs"],
    alternate_names: [],
  },
  "Sacramento State": {
    logo: "sacramento_state.png",
    mascots: "Hornets",
    alternate_names: ["Sacramento St.", "Sacramento St"],
    endzone_abbreviation: "SACST",
    endzone_hex_color: "00563F",
    alternate_mascots: ["Lady Hornets"],
  },
  "Sacred Heart": {
    logo: "sacred_heart.png",
    mascots: "Pioneers",
    endzone_abbreviation: "SH",
    endzone_hex_color: "CE1126",
    alternate_mascots: ["Lady Pioneers"],
    alternate_names: [],
  },
  "Saint Francis": {
    logo: "saint_francis.png",
    mascots: "Red Flash",
    endzone_abbreviation: "SFU",
    endzone_hex_color: "CC0000",
    alternate_mascots: ["Lady Red Flash"],
    alternate_names: [],
  },
  "Saint Louis": {
    logo: "saint_louis.png",
    mascots: "Billikens",
    endzone_abbreviation: "SLU",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Billikens"],
    alternate_names: [],
  },
  "Saint Mary's": {
    logo: "saint_marys.png",
    mascots: "Gaels",
    alternate_names: ["Saint-Mary's"],
    endzone_abbreviation: "SMC",
    endzone_hex_color: "003DA5",
    alternate_mascots: ["Lady Gaels"],
  },
  "Saint Peter's": {
    logo: "saint_peters.png",
    mascots: "Peacocks",
    endzone_abbreviation: "SPU",
    endzone_hex_color: "00539F",
    alternate_mascots: ["Lady Peacocks"],
    alternate_names: [],
  },
  "Sam Houston State": {
    logo: "sam_houston_state.png",
    mascots: "Bearkats",
    alternate_names: ["Sam Houston", "Sam Houston St.", "Sam Houston St"],
    endzone_abbreviation: "SHSU",
    endzone_hex_color: "FF6A00",
    alternate_mascots: ["Lady Bearkats"],
  },
  "Samford": {
    logo: "samford.png",
    mascots: "Bulldogs",
    endzone_abbreviation: "SAMF",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Bulldogs"],
    alternate_names: [],
  },
  "San Diego": {
    logo: "san_diego.png",
    mascots: "Toreros",
    endzone_abbreviation: "SD",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Toreros"],
    alternate_names: [],
  },
  "San Diego State": {
    logo: "san_diego_state.png",
    mascots: "Aztecs",
    alternate_names: ["San Diego St.", "San Diego St"],
    endzone_abbreviation: "SDSU",
    endzone_hex_color: "BA0C2F",
    alternate_mascots: ["Lady Aztecs"],
  },
  "San Francisco": {
    logo: "san_francisco.png",
    mascots: "Dons",
    endzone_abbreviation: "SF",
    endzone_hex_color: "00543C",
    alternate_mascots: ["Lady Dons"],
    alternate_names: [],
  },
  "San Jose State": {
    logo: "san_jose_state.png",
    mascots: "Spartans",
    alternate_names: ["San Jose St.", "San Jose St"],
    endzone_abbreviation: "SJSU",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Spartans"],
  },
  "Santa Clara": {
    logo: "santa_clara.png",
    mascots: "Broncos",
    endzone_abbreviation: "SCU",
    endzone_hex_color: "B30838",
    alternate_mascots: ["Lady Broncos"],
    alternate_names: [],
  },
  "Savannah State": {
    logo: "savannah_state.png",
    mascots: "Tigers",
    alternate_names: ["Savannah St.", "Savannah St"],
    endzone_abbreviation: "SSU",
    endzone_hex_color: "0033A0",
    alternate_mascots: ["Lady Tigers"],
  },
  "Seattle": {
    logo: "seattle.png",
    mascots: "Redhawks",
    endzone_abbreviation: "SEA",
    endzone_hex_color: "C8102E",
    alternate_mascots: ["Lady Redhawks"],
    alternate_names: [],
  },
  "Seton Hall": {
    logo: "seton_hall.png",
    mascots: "Pirates",
    endzone_abbreviation: "SETON",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Pirates"],
    alternate_names: [],
  },
  "Siena": {
    logo: "siena.png",
    mascots: "Saints",
    endzone_abbreviation: "SIENA",
    endzone_hex_color: "00543C",
    alternate_mascots: ["Lady Saints"],
    alternate_names: [],
  },
  "South Alabama": {
    logo: "south_alabama.png",
    mascots: "Jaguars",
    endzone_abbreviation: "SALA",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Jaguars"],
    alternate_names: [],
  },
  "South Carolina": {
    logo: "south_carolina.png",
    mascots: "Gamecocks",
    endzone_abbreviation: "SC",
    endzone_hex_color: "73000A",
    alternate_mascots: ["Lady Gamecocks"],
    alternate_names: [],
  },
  "South Carolina State": {
    logo: "south_carolina_state.png",
    mascots: "Bulldogs",
    alternate_names: ["South Carolina St.", "South Carolina St"],
    endzone_abbreviation: "SCSU",
    endzone_hex_color: "862633",
    alternate_mascots: ["Lady Bulldogs"],
  },
  "South Dakota": {
    logo: "south_dakota.png",
    mascots: "Coyotes",
    endzone_abbreviation: "SD",
    endzone_hex_color: "D31245",
    alternate_mascots: ["Lady Coyotes"],
    alternate_names: [],
  },
  "South Dakota State": {
    logo: "south_dakota_state.png",
    mascots: "Jackrabbits",
    alternate_names: ["South Dakota St.", "South Dakota St"],
    endzone_abbreviation: "SDSU",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Jackrabbits"],
  },
  "South Florida": {
    logo: "south_florida.png",
    mascots: "Bulls",
    endzone_abbreviation: "USF",
    endzone_hex_color: "006747",
    alternate_mascots: ["Lady Bulls"],
    alternate_names: [],
  },
  "Southern": {
    logo: "southern.png",
    mascots: "Jaguars",
    alternate_names: ["Southern U."],
    endzone_abbreviation: "SU",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Jaguars"],
  },
  "Southern Illinois": {
    logo: "southern_illinois.png",
    mascots: "Salukis",
    endzone_abbreviation: "SIU",
    endzone_hex_color: "660000",
    alternate_mascots: ["Lady Salukis"],
    alternate_names: [],
  },
  "Southern Indiana": {
    logo: "southern_indiana.png",
    mascots: "Screaming Eagles",
    endzone_abbreviation: "SIU",
    endzone_hex_color: "C8102E",
    alternate_mascots: ["Lady Screaming Eagles"],
    alternate_names: [],
  },
  "Southern Miss": {
    logo: "southern_mississippi.png",
    mascots: "Golden Eagles",
    alternate_names: ["Southern Miss."],
    endzone_abbreviation: "USM",
    endzone_hex_color: "000000",
    alternate_mascots: ["Lady Golden Eagles"],
  },
  "Southern Utah": {
    logo: "southern_utah.png",
    mascots: "Thunderbolts",
    endzone_abbreviation: "SUU",
    endzone_hex_color: "BA0C2F",
    alternate_mascots: ["Lady Thunderbolts"],
    alternate_names: [],
  },
  "St. Bonaventure": {
    logo: "saint_bonaventure.png",
    mascots: "Bonnies",
    endzone_abbreviation: "STBON",
    endzone_hex_color: "653024",
    alternate_mascots: ["Lady Bonnies"],
    alternate_names: [],
  },
  "St. Cloud State": {
    logo: "saint_cloud_state.png",
    mascots: "Huskies",
    alternate_names: ["St. Cloud St.", "St. Cloud St"],
    endzone_abbreviation: "SCSU",
    endzone_hex_color: "000000",
    alternate_mascots: ["Lady Huskies"],
  },
  "St. John's": {
    logo: "saint_johns.png",
    mascots: "Red Storm",
    endzone_abbreviation: "SJU",
    endzone_hex_color: "CE1141",
    alternate_mascots: ["Lady Red Storm"],
    alternate_names: [],
  },
  "St. Joseph's": {
    logo: "saint_josephs.png",
    mascots: "Hawks",
    endzone_abbreviation: "SJU",
    endzone_hex_color: "881B1E",
    alternate_mascots: ["Lady Hawks"],
    alternate_names: [],
  },
  "St. Thomas": {
    logo: "saint_thomas.png",
    mascots: "Tommies",
    endzone_abbreviation: "STTH",
    endzone_hex_color: "512888",
    alternate_mascots: ["Lady Tommies"],
    alternate_names: [],
  },
  "Stanford": {
    logo: "stanford.png",
    mascots: "Cardinal",
    endzone_abbreviation: "STAN",
    endzone_hex_color: "8C1515",
    alternate_mascots: ["Lady Cardinal"],
    alternate_names: [],
  },
  "Stephen F. Austin": {
    logo: "stephen_f_austin.png",
    mascots: "Lumberjacks",
    endzone_abbreviation: "SFA",
    endzone_hex_color: "4F2170",
    alternate_mascots: ["Lady Lumberjacks"],
    alternate_names: [],
  },
  "Stetson": {
    logo: "stetson.png",
    mascots: "Hatters",
    endzone_abbreviation: "STET",
    endzone_hex_color: "006747",
    alternate_mascots: ["Lady Hatters"],
    alternate_names: [],
  },
  "Stonehill": {
    logo: "stonehill.png",
    mascots: "Skyhawks",
    endzone_abbreviation: "STONE",
    endzone_hex_color: "330072",
    alternate_mascots: ["Lady Skyhawks"],
    alternate_names: [],
  },
  "Stony Brook": {
    logo: "stony_brook.png",
    mascots: "Seawolves",
    endzone_abbreviation: "STONY",
    endzone_hex_color: "990000",
    alternate_mascots: ["Lady Seawolves"],
    alternate_names: [],
  },
  "Syracuse": {
    logo: "syracuse.png",
    mascots: "Orange",
    endzone_abbreviation: "SYRA",
    endzone_hex_color: "F76900",
    alternate_mascots: ["Lady Orange"],
    alternate_names: [],
  },
  "TCU": {
    logo: "texas_christian.png",
    mascots: "Horned Frogs",
    endzone_abbreviation: "TCU",
    endzone_hex_color: "4D1979",
    alternate_mascots: ["Lady Horned Frogs"],
    alternate_names: [],
  },
  "Tarleton": {
    logo: "tarleton.png",
    mascots: "Texans",
    alternate_names: ["Tarleton State"],
    endzone_abbreviation: "TAR",
    endzone_hex_color: "4F2170",
    alternate_mascots: ["Lady Texans"],
  },
  "Temple": {
    logo: "temple.png",
    mascots: "Owls",
    endzone_abbreviation: "TEM",
    endzone_hex_color: "9B1B2F",
    alternate_mascots: ["Lady Owls"],
    alternate_names: [],
  },
  "Tennessee": {
    logo: "tennessee.png",
    mascots: "Volunteers",
    endzone_abbreviation: "TENN",
    endzone_hex_color: "FF8200",
    alternate_mascots: ["Lady Volunteers"],
    alternate_names: [],
  },
  "Tennessee State": {
    logo: "tennessee_state.png",
    mascots: "Tigers",
    alternate_names: ["Tennessee St.", "Tennessee St"],
    endzone_abbreviation: "TSU",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Tigers"],
  },
  "Tennessee Tech": {
    logo: "tennessee_tech.png",
    mascots: "Golden Eagles",
    endzone_abbreviation: "TTU",
    endzone_hex_color: "4F2170",
    alternate_mascots: ["Lady Golden Eagles"],
    alternate_names: [],
  },
  "Texas": {
    logo: "texas.png",
    mascots: "Longhorns",
    endzone_abbreviation: "TEX",
    endzone_hex_color: "BF5700",
    alternate_mascots: ["Lady Longhorns"],
    alternate_names: [],
  },
  "Texas - San Antonio": {
    logo: "texas_san_antonio.png",
    mascots: "Roadrunners",
    alternate_names: ["UTSA"],
    endzone_abbreviation: "UTSA",
    endzone_hex_color: "0C2340",
    alternate_mascots: ["Lady Roadrunners"],
  },
  "Texas A&M": {
    logo: "texas_a_m.png",
    mascots: "Aggies",
    endzone_abbreviation: "TAMU",
    endzone_hex_color: "500000",
    alternate_mascots: ["Lady Aggies"],
    alternate_names: [],
  },
  "Texas A&M - CC": {
    logo: "texas_a_m_corpus_christi.png",
    mascots: "Islanders",
    alternate_names: ["Texas A&M - Corpus Christi"],
    endzone_abbreviation: "TAMCC",
    endzone_hex_color: "0067C5",
    alternate_mascots: ["Lady Islanders"],
  },
  "Texas Southern": {
    logo: "texas_southern.png",
    mascots: "Tigers",
    endzone_abbreviation: "TXSO",
    endzone_hex_color: "660000",
    alternate_mascots: ["Lady Tigers"],
    alternate_names: [],
  },
  "Texas State": {
    logo: "texas_state.png",
    mascots: "Bobcats",
    alternate_names: ["Texas St.", "Texas St"],
    endzone_abbreviation: "TXST",
    endzone_hex_color: "501214",
    alternate_mascots: ["Lady Bobcats"],
  },
  "Texas Tech": {
    logo: "texas_tech.png",
    mascots: "Red Raiders",
    alternate_mascots: ["Lady Raiders", "Lady Red Raiders"],
    endzone_abbreviation: "TTU",
    endzone_hex_color: "CC0000",
    alternate_names: [],
  },
  "The Citadel": {
    logo: "citadel.png",
    mascots: "Bulldogs",
    endzone_abbreviation: "CITA",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Bulldogs"],
    alternate_names: [],
  },
  "Toledo": {
    logo: "toledo.png",
    mascots: "Rockets",
    endzone_abbreviation: "TOLE",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Rockets"],
    alternate_names: [],
  },
  "Towson": {
    logo: "towson.png",
    mascots: "Tigers",
    endzone_abbreviation: "TOWS",
    endzone_hex_color: "FFAA00",
    alternate_mascots: ["Lady Tigers"],
    alternate_names: [],
  },
  "Troy": {
    logo: "troy.png",
    mascots: "Trojans",
    endzone_abbreviation: "TROY",
    endzone_hex_color: "8B0015",
    alternate_mascots: ["Lady Trojans"],
    alternate_names: [],
  },
  "Tulane": {
    logo: "tulane.png",
    mascots: "Green Wave",
    endzone_abbreviation: "TULA",
    endzone_hex_color: "006747",
    alternate_mascots: ["Lady Green Wave"],
    alternate_names: [],
  },
  "Tulsa": {
    logo: "tulsa.png",
    mascots: "Golden Hurricane",
    endzone_abbreviation: "TULS",
    endzone_hex_color: "002D72",
    alternate_mascots: ["Lady Golden Hurricane"],
    alternate_names: [],
  },
  "UAB": {
    logo: "alabama_birmingham.png",
    mascots: "Blazers",
    endzone_abbreviation: "UAB",
    endzone_hex_color: "1E6E3C",
    alternate_mascots: ["Lady Blazers"],
    alternate_names: [],
  },
  "UC Davis": {
    logo: "california_davis.png",
    mascots: "Aggies",
    endzone_abbreviation: "UCD",
    endzone_hex_color: "002855",
    alternate_mascots: ["Lady Aggies"],
    alternate_names: [],
  },
  "UC Irvine": {
    logo: "california_irvine.png",
    mascots: "Anteaters",
    endzone_abbreviation: "UCI",
    endzone_hex_color: "003DA5",
    alternate_mascots: ["Lady Anteaters"],
    alternate_names: [],
  },
  "UC Riverside": {
    logo: "california_riverside.png",
    mascots: "Highlanders",
    endzone_abbreviation: "UCR",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Highlanders"],
    alternate_names: [],
  },
  "UC San Diego": {
    logo: "california_san_diego.png",
    mascots: "Tritons",
    endzone_abbreviation: "UCSD",
    endzone_hex_color: "003A70",
    alternate_mascots: ["Lady Tritons"],
    alternate_names: [],
  },
  "UCF": {
    logo: "central_florida.png",
    mascots: "Knights",
    endzone_abbreviation: "UCF",
    endzone_hex_color: "000000",
    alternate_mascots: ["Lady Knights"],
    alternate_names: [],
  },
  "UCLA": {
    logo: "california_los_angeles.png",
    mascots: "Bruins",
    endzone_abbreviation: "UCLA",
    endzone_hex_color: "2774AE",
    alternate_mascots: ["Lady Bruins"],
    alternate_names: [],
  },
  "UCSB": {
    logo: "california_santa_barbara.png",
    mascots: "Gauchos",
    alternate_names: ["UC Santa Barbara"],
    endzone_abbreviation: "UCSB",
    endzone_hex_color: "003660",
    alternate_mascots: ["Lady Gauchos"],
  },
  "UConn": {
    logo: "connecticut.png",
    mascots: "Huskies",
    alternate_names: ["Connecticut"],
    endzone_abbreviation: "UCONN",
    endzone_hex_color: "000E2F",
    alternate_mascots: ["Lady Huskies"],
  },
  "UIC": {
    logo: "illinois_chicago.png",
    endzone_abbreviation: "UIC",
    endzone_hex_color: "001E62",
    alternate_mascots: [],
    alternate_names: [],
  },
  "UMBC": {
    logo: "maryland_baltimore_county.png",
    mascots: "Retrievers",
    endzone_abbreviation: "UMBC",
    endzone_hex_color: "000000",
    alternate_mascots: ["Lady Retrievers"],
    alternate_names: [],
  },
  "UMass Lowell": {
    logo: "massachusetts_lowell.png",
    mascots: "River Hawks",
    endzone_abbreviation: "UML",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady River Hawks"],
    alternate_names: [],
  },
  "UNC Asheville": {
    logo: "north_carolina_asheville.png",
    mascots: "Bulldogs",
    endzone_abbreviation: "UNCA",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Bulldogs"],
    alternate_names: [],
  },
  "UNC Greensboro": {
    logo: "north_carolina_greensboro.png",
    mascots: "Spartans",
    endzone_abbreviation: "UNCG",
    endzone_hex_color: "002654",
    alternate_mascots: ["Lady Spartans"],
    alternate_names: [],
  },
  "UNC Wilmington": {
    logo: "north_carolina_wilmington.png",
    endzone_abbreviation: "UNCW",
    endzone_hex_color: "006272",
    alternate_mascots: [],
    alternate_names: [],
  },
  "UNLV": {
    logo: "nevada_las_vegas.png",
    mascots: "Rebels",
    endzone_abbreviation: "UNLV",
    endzone_hex_color: "B10202",
    alternate_mascots: ["Lady Rebels"],
    alternate_names: [],
  },
  "USC": {
    logo: "southern_california.png",
    mascots: "Trojans",
    alternate_names: ["Southern California"],
    endzone_abbreviation: "USC",
    endzone_hex_color: "990000",
    alternate_mascots: ["Lady Trojans"],
  },
  "USC Upstate": {
    logo: "south_carolina_upstate.png",
    mascots: "Spartans",
    alternate_names: ["South Carolina Upstate"],
    endzone_abbreviation: "USCU",
    endzone_hex_color: "006747",
    alternate_mascots: ["Lady Spartans"],
  },
  "UT Arlington": {
    logo: "texas_arlington.png",
    mascots: "Mavericks",
    endzone_abbreviation: "UTA",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Mavericks"],
    alternate_names: [],
  },
  "UT Martin": {
    logo: "tennessee_martin.png",
    mascots: "Skyhawks",
    endzone_abbreviation: "UTM",
    endzone_hex_color: "FF6A00",
    alternate_mascots: ["Lady Skyhawks"],
    alternate_names: [],
  },
  "UTEP": {
    logo: "texas_el_paso.png",
    mascots: "Miners",
    endzone_abbreviation: "UTEP",
    endzone_hex_color: "FF6A00",
    alternate_mascots: ["Lady Miners"],
    alternate_names: [],
  },
  "UTPB": {
    logo: "texas_permian_basin.png",
    mascots: "Falcons",
    endzone_abbreviation: "UTPB",
    endzone_hex_color: "FF6A00",
    alternate_mascots: ["Lady Falcons"],
    alternate_names: [],
  },
  "UTRGV": {
    logo: "texas_rio_grande_valley.png",
    mascots: "Vaqueros",
    alternate_names: ["Texas Rio Grande Valley"],
    endzone_abbreviation: "UTRGV",
    endzone_hex_color: "FF6A00",
    alternate_mascots: ["Lady Vaqueros"],
  },
  "Union": {
    logo: "union.png",
    mascots: "Dutchmen",
    endzone_abbreviation: "UNION",
    endzone_hex_color: "8B0015",
    alternate_mascots: ["Lady Dutchmen"],
    alternate_names: [],
  },
  "Utah": {
    logo: "utah.png",
    mascots: "Utes",
    endzone_abbreviation: "UTAH",
    endzone_hex_color: "CC0000",
    alternate_mascots: ["Lady Utes"],
    alternate_names: [],
  },
  "Utah State": {
    logo: "utah_state.png",
    mascots: "Aggies",
    alternate_names: ["Utah St.", "Utah St"],
    endzone_abbreviation: "UTST",
    endzone_hex_color: "003057",
    alternate_mascots: ["Lady Aggies"],
  },
  "Utah Tech": {
    logo: "utah_tech.png",
    mascots: "Trailblazers",
    endzone_abbreviation: "UTTECH",
    endzone_hex_color: "CC0000",
    alternate_mascots: ["Lady Trailblazers"],
    alternate_names: [],
  },
  "Utah Valley": {
    logo: "utah_valley.png",
    mascots: "Wolverines",
    endzone_abbreviation: "UVU",
    endzone_hex_color: "165734",
    alternate_mascots: ["Lady Wolverines"],
    alternate_names: [],
  },
  "VCU": {
    logo: "virginia_commonwealth.png",
    mascots: "Rams",
    endzone_abbreviation: "VCU",
    endzone_hex_color: "000000",
    alternate_mascots: ["Lady Rams"],
    alternate_names: [],
  },
  "VMI": {
    logo: "virginia_military.png",
    mascots: "Keydets",
    endzone_abbreviation: "VMI",
    endzone_hex_color: "BA0C2F",
    alternate_mascots: ["Lady Keydets"],
    alternate_names: [],
  },
  "Valparaiso": {
    logo: "valparaiso.png",
    mascots: "Beacons",
    endzone_abbreviation: "VALPO",
    endzone_hex_color: "63513B",
    alternate_mascots: ["Lady Beacons"],
    alternate_names: [],
  },
  "Vanderbilt": {
    logo: "vanderbilt.png",
    mascots: "Commodores",
    endzone_abbreviation: "VANDY",
    endzone_hex_color: "866D4B",
    alternate_mascots: ["Lady Commodores"],
    alternate_names: [],
  },
  "Vermont": {
    logo: "vermont.png",
    mascots: "Catamounts",
    endzone_abbreviation: "VERM",
    endzone_hex_color: "006747",
    alternate_mascots: ["Lady Catamounts"],
    alternate_names: [],
  },
  "Villanova": {
    logo: "villanova.png",
    mascots: "Wildcats",
    endzone_abbreviation: "VILL",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Wildcats"],
    alternate_names: [],
  },
  "Virginia": {
    logo: "virginia.png",
    mascots: "Cavaliers",
    endzone_abbreviation: "UVA",
    endzone_hex_color: "F84C1E",
    alternate_mascots: ["Lady Cavaliers"],
    alternate_names: [],
  },
  "Virginia Tech": {
    logo: "virginia_tech.png",
    mascots: "Hokies",
    endzone_abbreviation: "VT",
    endzone_hex_color: "630031",
    alternate_mascots: ["Lady Hokies"],
    alternate_names: [],
  },
  "WKU": {
    logo: "western_kentucky.png",
    mascots: "Hilltoppers",
    alternate_names: ["Western Kentucky"],
    endzone_abbreviation: "WKU",
    endzone_hex_color: "C8102E",
    alternate_mascots: ["Lady Hilltoppers"],
  },
  "Wagner": {
    logo: "wagner.png",
    mascots: "Seahawks",
    endzone_abbreviation: "WAG",
    endzone_hex_color: "006747",
    alternate_mascots: ["Lady Seahawks"],
    alternate_names: [],
  },
  "Wake Forest": {
    logo: "wake_forest.png",
    mascots: "Demon Deacons",
    endzone_abbreviation: "WAKE",
    endzone_hex_color: "9E7E38",
    alternate_mascots: ["Lady Demon Deacons"],
    alternate_names: [],
  },
  "Washburn": {
    logo: "washburn.png",
    mascots: "Ichabods",
    endzone_abbreviation: "WASH",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Ichabods"],
    alternate_names: [],
  },
  "Washington": {
    logo: "washington.png",
    mascots: "Huskies",
    endzone_abbreviation: "WASH",
    endzone_hex_color: "4B2E83",
    alternate_mascots: ["Lady Huskies"],
    alternate_names: [],
  },
  "Washington State": {
    logo: "washington_state.png",
    mascots: "Cougars",
    alternate_names: ["Washington St.", "Washington St"],
    endzone_abbreviation: "WSU",
    endzone_hex_color: "981E32",
    alternate_mascots: ["Lady Cougars"],
  },
  "Wayne State": {
    logo: "wayne_state.png",
    mascots: "Wildcats",
    alternate_names: ["Wayne St.", "Wayne St"],
    endzone_abbreviation: "WSC",
    endzone_hex_color: "000000",
    alternate_mascots: ["Lady Wildcats"],
  },
  "Weber State": {
    logo: "weber_state.png",
    mascots: "Wildcats",
    alternate_names: ["Weber St.", "Weber St"],
    endzone_abbreviation: "WEB",
    endzone_hex_color: "512888",
    alternate_mascots: ["Lady Wildcats"],
  },
  "West Georgia": {
    logo: "west_georgia.png",
    mascots: "Wolves",
    alternate_names: ["West Ga."],
    endzone_abbreviation: "WGU",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Wolves"],
  },
  "West Virginia": {
    logo: "west_virginia.png",
    mascots: "Mountaineers",
    endzone_abbreviation: "WVU",
    endzone_hex_color: "002855",
    alternate_mascots: ["Lady Mountaineers"],
    alternate_names: [],
  },
  "Western Carolina": {
    logo: "western_carolina.png",
    mascots: "Catamounts",
    endzone_abbreviation: "WCU",
    endzone_hex_color: "592A8A",
    alternate_mascots: ["Lady Catamounts"],
    alternate_names: [],
  },
  "Western Illinois": {
    logo: "western_illinois.png",
    mascots: "Leathernecks",
    endzone_abbreviation: "WIU",
    endzone_hex_color: "461D7C",
    alternate_mascots: ["Lady Leathernecks"],
    alternate_names: ["Western Ill", "Western Ill."],
  },
  "Western Michigan": {
    logo: "western_michigan.png",
    mascots: "Broncos",
    endzone_abbreviation: "WMU",
    endzone_hex_color: "693F23",
    alternate_mascots: ["Lady Broncos"],
    alternate_names: [],
  },
  "Wichita State": {
    logo: "wichita_state.png",
    mascots: "Shockers",
    alternate_names: ["Wichita St.", "Wichita St"],
    endzone_abbreviation: "WSU",
    endzone_hex_color: "000000",
    alternate_mascots: ["Lady Shockers"],
  },
  "William & Mary": {
    logo: "william_mary.png",
    mascots: "Tribe",
    endzone_abbreviation: "W&M",
    endzone_hex_color: "006747",
    alternate_mascots: ["Lady Tribe"],
    alternate_names: [],
  },
  "Winthrop": {
    logo: "winthrop.png",
    mascots: "Eagles",
    endzone_abbreviation: "WIN",
    endzone_hex_color: "862633",
    alternate_mascots: ["Lady Eagles"],
    alternate_names: [],
  },
  "Wisconsin": {
    logo: "wisconsin.png",
    mascots: "Badgers",
    endzone_abbreviation: "WISC",
    endzone_hex_color: "C5050C",
    alternate_mascots: ["Lady Badgers"],
    alternate_names: [],
  },
  "Wisconsin - Green Bay": {
    logo: "wisconsin_green_bay.png",
    mascots: "Phoenix",
    endzone_abbreviation: "GB",
    endzone_hex_color: "006747",
    alternate_mascots: ["Lady Phoenix"],
    alternate_names: [],
  },
  "Wisconsin - Milwaukee": {
    logo: "wisconsin_milwaukee.png",
    mascots: "Panthers",
    endzone_abbreviation: "MIL",
    endzone_hex_color: "FFCC00",
    alternate_mascots: ["Lady Panthers"],
    alternate_names: [],
  },
  "Wofford": {
    logo: "wofford.png",
    mascots: "Terriers",
    endzone_abbreviation: "WOFF",
    endzone_hex_color: "000000",
    alternate_mascots: ["Lady Terriers"],
    alternate_names: [],
  },
  "Wright State": {
    logo: "wright_state.png",
    mascots: "Raiders",
    alternate_names: ["Wright St.", "Wright St"],
    endzone_abbreviation: "WSU",
    endzone_hex_color: "00573F",
    alternate_mascots: ["Lady Raiders"],
  },
  "Wyoming": {
    logo: "wyoming.png",
    mascots: "Cowboys",
    endzone_abbreviation: "WYO",
    endzone_hex_color: "492F24",
    alternate_mascots: ["Lady Cowboys"],
    alternate_names: [],
  },
  "Xavier": {
    logo: "xavier.png",
    mascots: "Musketeers",
    endzone_abbreviation: "XAV",
    endzone_hex_color: "003087",
    alternate_mascots: ["Lady Musketeers"],
    alternate_names: [],
  },
  "Yale": {
    logo: "yale.png",
    mascots: "Bulldogs",
    endzone_abbreviation: "YALE",
    endzone_hex_color: "0F4D92",
    alternate_mascots: ["Lady Bulldogs"],
    alternate_names: [],
  },
  "Youngstown State": {
    logo: "youngstown_state.png",
    mascots: "Penguins",
    alternate_names: ["Youngstown St.", "Youngstown St"],
    endzone_abbreviation: "YSU",
    endzone_hex_color: "C8102E",
    alternate_mascots: ["Lady Penguins"],
  },
}
